module.exports = __webpack_public_path__ + "480b61f0cadffa6945f99e4e4e122c31.pdf";